import { render, staticRenderFns } from "./PrinterModal.vue?vue&type=template&id=12b0c9a4&scoped=true"
import script from "./PrinterModal.vue?vue&type=script&lang=ts"
export * from "./PrinterModal.vue?vue&type=script&lang=ts"
import style0 from "./PrinterModal.vue?vue&type=style&index=0&id=12b0c9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0c9a4",
  null
  
)

export default component.exports